/* eslint-disable no-param-reassign */
import { types } from "mobx-state-tree";

export type Year = {
  year: number;
  guest_count: number;
  artist_count: number;
  scene_count: number;
  extra_info?: string;
};

export const HistoryYearShort = types.model({
  artist_count: types.optional(types.integer, 0),
  extra_info: types.optional(types.string, ""),
  guest_count: types.optional(types.integer, 0),
  scene_count: types.optional(types.integer, 0),
  year: types.optional(types.integer, 2020),
});

export const Video = types.model({
  mp4: types.optional(types.string, ""),
  video_webm: types.optional(types.string, ""),
});

export const HistoryYear = types.model({
  artist_count: types.optional(types.integer, 0),
  extra_info: types.optional(types.string, ""),
  info: types.optional(types.string, ""),
  video: types.optional(Video, {}),
  guest_count: types.optional(types.integer, 0),
  scene_count: types.optional(types.integer, 0),
  year: types.optional(types.integer, 2020),
});
